import moment from "moment";

import { LAUNCH_DATE } from "./constants";

export const getPeriodFilters = ({ period, report, currentUser }) => {
  const endTime = new Date();
  const filters = {
    start_time: LAUNCH_DATE,
    end_time: endTime,
    user_id: undefined
  };

  if (period === "18-months") {
    filters.start_time = moment().subtract(18, "months");
  }

  if (report === "my-scores") {
    filters.user_id = currentUser.id;
  }

  return filters;
};



// WEBPACK FOOTER //
// ./app/modules/HighScores/utils.js